import React from 'react';
import { useFormRestorePassword } from '../../hooks/useFormRestorePassword';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';

const initialForm = {
    correo_electronico: "",
}

const validationsFrom = (form) => {
    let errors = {};

    if(!form.correo_electronico.trim()) {
        errors.correo_electronico = "El Campo (Correo electrónico) es requerido";
    } 
    
    return errors;
}

const RestorePassword = () => { 
    const {form, 
        errors,
        loading,
        response,
        handleChange,
        handleBlur,
        handleLogin} = useFormRestorePassword(initialForm, validationsFrom);
    

    return (
        <div className='surface-ground px-4 py-8 md:px-6 lg:px-8 flex align-items-center justify-content-center'>
            <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
                <div className="text-center mb-5">
                    <img src="assets/layout/images/LOGOTIPO SEC PNG.png" alt="hyper" height="120" className="mb-3" />
                    <div className="text-900 text-3xl font-medium mb-3">RECUPERAR CONTRASEÑA</div>
                    <span className="text-600 font-medium line-height-3">
                        Ingresar tu correo electrónico para recibir un código de verificación y recuperar tu contraseña.
                    </span>
                </div>
            
                <form onSubmit={handleLogin}>
                    <div>
                        <label htmlFor="correo_electronico" className="block text-900 font-medium mb-2">Correo Electrónico:</label>
                        {errors.correo_electronico && <small className="p-error">{errors.correo_electronico}</small>}
                        <InputText id="correo_electronico" name="correo_electronico" type="email" className={`w-full mb-3 ${errors.correo_electronico && 'p-invalid'}`} value={form.correo_electronico} onChange={handleChange} onBlur={handleBlur} />
                        {loading && <Loader />}
                        {response && <MessageDetail color="error" mensaje={response} />}
                        <Button type="submit" disabled={loading} label="Enviar" icon="pi pi-at" className="w-full p-button-rounded" />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default RestorePassword;